exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".box-email{background:#fff;width:320px;margin:auto;padding:20px;margin-top:20px;border-radius:20px}.email{color:#009865}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/Confirm.vue"],"names":[],"mappings":"AACA,WACE,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAoB,CACrB,AACD,OACE,aAAc,CACf","file":"Confirm.vue","sourcesContent":["\n.box-email{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  border-radius: 20px;\n}\n.email{\n  color: #009865\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b0991f9e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/hotsite/Confirm.vue
// module id = 638
// module chunks = 40